import type { ReactNode } from "react";
import { Breakable } from "../components/Breakable";
import LabeledValue, {
  type ILabeledValueProps,
} from "../components/LabeledValue";

type RenderOptions = {
  breakValues?: boolean;
  fallback?: ReactNode;
};

export const renderLabeledValues = (
  items: ILabeledValueProps[],
  options: RenderOptions = {},
) => {
  const { breakValues = false, fallback = "-" } = options;

  return items.map((item, index) => {
    const key = `${String(item.label)}-${String(item.value ?? "")}-${index}`;

    return (
      <LabeledValue
        key={key}
        {...item}
        value={
          breakValues ? (
            <Breakable fallback={fallback}>{item.value}</Breakable>
          ) : (
            item.value
          )
        }
      />
    );
  });
};
